import { Link } from 'react-router-dom';
import { EventDetails } from '../../../interfaces/userInterfaces';
import { useUser } from '../../../hooks/useUser';

export const EventListDisplay = (event: EventDetails) => {
  const { userAttendingEventsList } = useUser();
  return (
    <li key={`event-list-item-${event.id}`} className="event-list-item">
      <img
        className="event-list-image"
        src={
          event?.promotional_image ||
          'https://nqbvdgzoxvmdlnjovyqu.supabase.in/storage/v1/object/public/avatars/default-avatar/userexpression.png'
        }
      />
      <span style={{ display: 'flex', flexDirection: 'column' }}>
        {event.profiles && (
          <p style={{ margin: '1px' }}>{`Hosted by: ${event.profiles.username}`}</p>
        )}
        <Link
          to={`../event/${event.id}/${userAttendingEventsList?.includes(event.id) ? true : false}`}
          className="calendar-list-item"
        >{`${event.event_name}  :  ${event.date}`}</Link>
      </span>
    </li>
  );
};
